// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import {useLocation, useHistory} from 'react-router-dom';
import zurl from 'zurl';
// @ts-ignore
import _ from 'zutil';
import zescape from '/util/escape.js';

export const use_qs = ()=>{
    const {search} = useLocation();
    return zurl.qs_parse(search.slice(1), {safe: true});
};

export const use_qs_with_set = ()=>{
    const {search} = useLocation();
    const history = useHistory();
    const update_qs = (opt: object_of<string>)=>{
        const original_params = zurl.qs_parse(search.slice(1),
            {safe: true, disable_qid_parse: true});
        let params = zurl.qs_parse(search.slice(1), {safe: true});
        for (const k in opt)
        {
            if (!opt[k])
                delete params[k];
            else
                params[k] = opt[k];
        }
        if ('qid' in original_params)
        {
            // XXX mikita: we want to encode query to qid format, leaving
            // explicit query params non encoded
            const original_params_keys = Object.keys(original_params);
            params = {..._.pick(params, original_params_keys),
                qid: zurl.qs_pack_qid(params)};
        }
        let path = location.pathname;
        return zescape.uri(path, params);
    };
    const set_qs = (opt: object_of<string>)=>history.push(update_qs(opt));
    const replace_qs = (opt: object_of<string>)=>history.replace(
        update_qs(opt));
    return {qs: zurl.qs_parse(search.slice(1), {safe: true}), set_qs,
        replace_qs};
};
